import React, { useEffect } from "react";
import { withTranslation } from "react-i18next";
import $ from "jquery";
import PropTypes from "prop-types";

import {
  jobSiteKOColors,
  quoteKOColors,
  jobSiteKOStatuses,
  quoteKOStatuses,
} from "@utils/constants";

import "./Header.scss";

const Header = (props) => {
  const {
    t,
    koStatus,
    validatedQuotes,
    isQuote,
    siteKoStatus,
    showSiteInfo,
    currentQuoteTab,
    setSiteInfoVisiblity,
  } = props;

  const renderValidatedQuotesTab = () => {
    return validatedQuotes.map((item) => {
      return (
        // TODO styled component
        <li
          key={item.id}
          className={
            siteKoStatus > 1
              ? `${"kick-off-header__header-tab-item " + "quote-tab-"}${
                  item.id
                }`
              : "kick-off-header__header-tab-item disabled"
          }
          data-type={`kick-off-quote-${item.id}`}
          data-status={item.koStatus}
          data-id={item.id}
          onClick={(e) => {
            if (siteKoStatus > 1) {
              handleTabClick(e);
            }
          }}
        >
          {/* // TODO styled component */}
          <span data-identifier={`view-${item.id}`}>
            {`${t("KICK_OFF_PAGE_TAB_QUOTE")} ${item.id}`}
          </span>
          <div className="line-highlighter hide" />
        </li>
      );
    });
  };

  useEffect(() => {
    if (validatedQuotes?.length === 0) {
      $(".kick-off-header__header-tab-item")
        .removeClass("active")
        .find(".line-highlighter")
        .addClass("hide");
      $(".kick-off-header__header-tab-item--site-info")
        .addClass("active")
        .find(".line-highlighter")
        .removeClass("hide");
      $(".quote-item-wrapper").addClass("hide");
      $(".kick-off-main-wrapper").show();
    }
  }, [validatedQuotes]);

  // Show site info tab if quote is not validated.
  useEffect(() => {
    if (showSiteInfo) {
      onTabItemClick($(".kick-off-header__header-tab-item--site-info"));
    }
  }, [showSiteInfo]);

  // If url has quoteId then make the quote tab active and show.
  useEffect(() => {
    if (currentQuoteTab && currentQuoteTab !== "") {
      const currentQuoteTabElement = $(`.quote-tab-${currentQuoteTab}`);
      if (currentQuoteTabElement.length > 0) {
        onTabItemClick(currentQuoteTabElement);
      }
    }
  }, [currentQuoteTab]);

  const handleTabClick = (e) => {
    onTabItemClick($(e.target));
  };

  const onTabItemClick = ($element) => {
    const id = $element
      .closest(".kick-off-header__header-tab-item")
      .data("type");
    if (
      !$element
        .closest(".kick-off-header__header-tab-item")
        .hasClass("disabled")
    ) {
      $(".kick-off-header__header-tab-item").removeClass("active");
      $(".kick-off-header__header-tab-item .line-highlighter").addClass("hide");
      $element
        .closest(".kick-off-header__header-tab-item")
        .addClass("active")
        .find(".line-highlighter")
        .removeClass("hide");
      $(".quote-item-wrapper").addClass("hide");
      if (id === "kickoff-general") {
        $(".quote-item-wrapper").addClass("hide");
        $(".kick-off-main-wrapper").show();
        setSiteInfoVisiblity(true);
      } else {
        $(".kick-off-main-wrapper").hide();
        $(`#${id}`).removeClass("hide");
      }
      props.onTabClick(
        $element.closest(".kick-off-header__header-tab-item").data("id")
      );
    }
  };

  const renderKOStatus = () => {
    if (isQuote) {
      return (
        // TODO styled component
        <div
          className={`validate-site title-banner-status ${quoteKOColors[koStatus]}`}
        >
          <span id="title-banner-status-info-text">
            {t(quoteKOStatuses[koStatus])}
          </span>
        </div>
      );
    }
    if (koStatus !== 0) {
      return (
        // TODO styled component
        <div
          className={`validate-site title-banner-status ${jobSiteKOColors[koStatus]}`}
        >
          <span id="title-banner-status-info-text">
            {t(jobSiteKOStatuses[koStatus])}
          </span>
        </div>
      );
    }
  };

  return (
    // TODO styled component
    <section className="kick-off-header">
      <header className="kick-off-header__wrapper">
        <section className="kick-off-header__header-left">
          <div className="kick-off-header__header-title-container">
            <ul className="kick-off-header__header-tabs">
              <li
                className="kick-off-header__header-tab-item kick-off-header__header-tab-item--site-info active"
                data-type="kickoff-general"
                data-status={koStatus}
                onClick={handleTabClick}
              >
                <div>
                  <span>{t("KICK_OFF_PAGE_TAB_SITE_INFORMATION")}</span>
                  <div className="line-highlighter" />
                </div>
              </li>
              {validatedQuotes && renderValidatedQuotesTab()}
            </ul>
          </div>
        </section>

        {/* TODO // styled component */}
        <section className="kick-off-header__header-right">
          {renderKOStatus()}
        </section>
      </header>
    </section>
  );
};

Header.propTypes = {
  t: PropTypes.func.isRequired,
  objectId: PropTypes.number,
};

Header.defaultProps = {
  objectId: null,
};
export default withTranslation()(Header);
